module.exports = __webpack_public_path__ + "static/media/back.3a3efdc3.svg";